import axios from 'axios';

export default class RegisterService {
  public sendEmailService(account: any) {
    return axios.post('api/email/send', account);
  }

  // public sendEmailCode(account: any) {
  //   return axios.post('api/email/sendCode', account);
  // }

  // public verifyEmailCode(account: any) {
  //   return axios.post('api/email/verify', account);
  // }

  public verifyCode(account: any) {
    return axios.post('api/verify', account);
  }

  public verifyCodeUserExist(account: any) {
    return axios.post('api/verifyCode', account);
  }

  public login(account: any) {
    return axios.post('api/login', account);
  }

  // public verifyEmailCode2(account: any) {
  //   return axios.post('api/email/verifyCode', account);
  // }

  // public userReceive(account: any) {
  //   return axios.post('api/public/receive', account);
  // }

  public createUnActiveAccount(account: any) {
    return axios.post('api/public/create', account);
  }

  public sendOTP(account: any) {
    return axios.post('api/sendOTP', account);
  }

  public createGuestAccount(account: any) {
    return axios.post('api/create-guest', account);
  }

  public activeAccount(account: any) {
    return axios.post('api/active', account);
  }

  public checkUsernameExisted(username, countryCode: string) {
    return axios.get('api/public/checkUsernameExisted/' + username + '?countryCode=' + countryCode);
  }
}
